

var abandonedCarts = function()
{

    var _this = this;

    var container =  $( '[javascript="abandoned-carts"]' );

    var bindEvents = function()
    {
        $.fn.ensphere.veto.wysiwyg( '.redactor' );
    };

    this.api = {

        bindEvents : bindEvents,
        instantiable            : function()
        {
            return container.length
        }

    };

    return this.api;

};
